import React, { useState, useRef, useLayoutEffect } from 'react';
import atomize from '@quarkly/atomize';

function MyComponent() {
	const defaultLogo = 'https://uploads.quarkly.io/62ab65c921e43d0020961286/images/default_logo.svg?v=2023-11-05T20:42:24.350Z';
	const [logo, setLogo] = useState(defaultLogo);
	const [shopName, setShopName] = useState('Telegram магазин');
	const [buttonLink, setButtonLink] = useState('https://t.me/uShopWebBot');
	const [buttonName, setButtonName] = useState('Создать магазин');
	const [resultHtml, setResultHtml] = useState(null);
	const textResultRef = useRef(null);

	const handleGenerateClick = () => {
		const generatedHtml = `
      <div class="shop-header">
        <div class="shop-header__logo">
          <img src="${logo}" alt="Logo" />
        </div>
        <div class="shop-header__name">
          <span>${shopName}</span>
        </div>
        <div class "shop-header__links">
          <a class="shop-header-link" href="${buttonLink}" target="_blank">
            📢 ${buttonName}
          </a>
        </div>
      </div>
    `;
		setResultHtml(generatedHtml);
	};

	const handleResetClick = () => {
		setLogo(defaultLogo);
		setShopName('Telegram магазин');
		setButtonLink('https://t.me/uShopWebBot');
		setButtonName('Создать магазин');
		setResultHtml(null); // Clear the input fields

		document.getElementById('logo').value = '';
		document.getElementById('shopName').value = '';
		document.getElementById('buttonLink').value = '';
		document.getElementById('buttonName').value = '';
	};

	const handleCopyClick = () => {
		if (textResultRef.current) {
			textResultRef.current.select();
			document.execCommand('copy');
		}
	};

	const handleThemeToggleChange = e => {
		const body = document.body;

		if (e.target.checked) {
			body.classList.add('dark-theme');
		} else {
			body.classList.remove('dark-theme');
		}
	}; // Use useLayoutEffect for synchronous updates


	useLayoutEffect(() => {
		if (textResultRef.current) {
			textResultRef.current.value = resultHtml;
		}
	}, [resultHtml]);
	return <div className="uShopWebBotlogo">
		      
		<div className="theme-switch">
			        Темная тема
        
			<input type="checkbox" id="theme-toggle" onChange={handleThemeToggleChange} />
			        
			<label htmlFor="theme-toggle"></label>
			      
		</div>
		      
		<div className="container">
			        
			<div className="form-container">
				          
				<div id="resulttg">
					            
					<div className="shoptg">
						              
						<img className="shop-ligha" src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/header.svg?v=2023-11-05T20:42:24.353Z" alt="Light Logo" />
						              
						<img className="shop-dark" src="https://uploads.quarkly.io/62ab65c921e43d0020961286/images/dark_header.svg?v=2023-11-05T20:42:24.348Z" alt="Dark Logo" />
						            
					</div>
					          
				</div>
				          
				<div id="result">
					            
					<div className="shop-header">
						              
						<div className="shop-header__logo">
							                
							<img src={logo} alt="Logo" />
							              
						</div>
						              
						<div className="shop-header__name">
							                
							<span>
								{shopName}
							</span>
							              
						</div>
						              
						<div className="shop-header__links">
							                
							<a className="shop-header-link" href={buttonLink} target="_blank">
								                  📢 
								{buttonName}
								                
							</a>
							              
						</div>
						            
					</div>
					          
				</div>
				          
				<form id="form">
					            
					<input type="text" id="logo" placeholder="Ссылка на логотип" onChange={e => setLogo(e.target.value)} />
					            
					<input type="text" id="shopName" placeholder="Название магазина" onChange={e => setShopName(e.target.value)} />
					            
					<input type="text" id="buttonName" placeholder="Название кнопки" onChange={e => setButtonName(e.target.value)} />
					            
					<input type="text" id="buttonLink" placeholder="Ссылка кнопки" onChange={e => setButtonLink(e.target.value)} />
					            
					<div className="container buttonlogo">
						              
						<button id="generateBtn" type="button" onClick={handleGenerateClick}>
							Получить код
						</button>
						              
						<button id="resetBtn" type="button" onClick={handleResetClick}>
							Сбросить
						</button>
						            
					</div>
					          
				</form>
				        
			</div>
			        
			<div className="result-container">
				          
				<h3>
					Код для вставки:
				</h3>
				          
				<textarea id="textResult" rows="4" ref={textResultRef} readOnly></textarea>
				                
				<button id="copyBtn" type="button" onClick={handleCopyClick}>
					Скопировать код
				</button>
				        
			</div>
			   
      
		</div>
		    
	</div>;
}

export default atomize(MyComponent)({
	name: 'MyComponent',
	description: {
		en: 'A custom React component'
	}
});